import React, { useState, useEffect } from "react";
import { Hide, Show } from "react-iconly";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import "./register.scss";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import { usersignup, sendOtp, sendOtpSignUp } from "../../services/auth.service";
import { useDispatch } from "react-redux";
import { registerConsumer, registerProvider } from "../../slice/registerSlice";
import { setLoader } from "../../slice/commonSlice";
import { getAllContent,getContent } from "../../services/auth.service";
const UserRegister = (props) => {
  // ***************************************js start*********************************************************
  let navigate = useNavigate();
  const dispatch = useDispatch();

  const [input, setInput] = useState({});
  const [errors, setErrors] = useState({}); //Add state variables for form data and validation errors.
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [isChecked, setChecked] = useState(false);
  const [contentId, setContentId] = useState();
  const [content, setContent] = useState();
  const [showModal, setShowModal] = useState(false);

  // props.setUserVerifiyOtpModal(true)
  // return
  // ****************************************************************************************

    useEffect(() => {
      getallcontent()
  }, [])
  useEffect(() => {
      getcontent()
  }, [contentId])
  useEffect(() => {
    // Check if Google data exists in local storage
    const googleData = localStorage.getItem("userData");
    if (googleData) {
      // Parse Google data and pre-fill the form
      const parsedGoogleData = JSON.parse(googleData);

      setInput({
        firstName: parsedGoogleData.google_fname || "",
        lastName: parsedGoogleData.lastname || "",
        email: parsedGoogleData.google_email || "",
        profilePic: parsedGoogleData.pic || "",
        social_id: parsedGoogleData.google_id || "",
        verfied: parsedGoogleData.verfied || "",
        // Add other fields as needed
      });
    }

    const facebookData = localStorage.getItem("facebookData");
    const data = JSON.parse(facebookData);
    if (data) {
      setInput({
        firstName: data.name.split(" ")[0],
        lastName: data.name.split(" ")[1] || "",
        email: data.email,
        profilePic: data.picture.data || "",
        social_id: data.userID || "",
        socailName: data.graphDomain,
        // phone:data.phone
      });
    }
  }, []);

  const getallcontent = async () => {
    const result = await getAllContent();
    const searchObject = result.data.find((data) => data.slug == "terms");
    setContentId(searchObject._id)
  }

  const getcontent = async () => {
    const paylaod = { "_id": contentId }
    const result = await getContent(paylaod);
    setContent(result.data.content)
  }
  const handleToggleModal = async () => {

    setShowModal(!showModal);
  };
  // *******************************************************************************************
  const handleSubmit = async (e) => {
    e.preventDefault();
    localStorage.setItem("emailForforget", input.email);
    if (validateForm()) {
      await dispatch(setLoader(true));
      localStorage.setItem("customerInfo", input);
      const formData = new FormData();

      formData.append("firstName", input.firstName);
      formData.append("lastName", input.lastName);
      formData.append("email", input.email);
      formData.append("phone", input.phone);
      formData.append("password", input.password);
      formData.append("confirmPassword", input.confirmPassword);
      formData.append("profilePic", input.profilePic);
      formData.append("userType", "user");

      formData.append("social_id", input.social_id || 0);
      formData.append("socialName", input.socailName || "");
      try {
        await dispatch(registerProvider(formData));
        const sendotpRes = await sendOtpSignUp({ email: input.email });
        if (sendotpRes?.data?.status === true) {
          toast.success(sendotpRes.data.message, {
            position: toast.POSITION.TOP_CENTER,
          });
          props.setRegisterModal(false);
          props.setUserVerifiyOtpModal(true);
          await dispatch(setLoader(false));
        } else {
          toast.warning(sendotpRes.data.message, {
            position: toast.POSITION.TOP_CENTER,
          });
          props.setRegisterModal(true);
          props.setUserVerifiyOtpModal(false);
          await dispatch(setLoader(false));
        }
      } catch (e) {
        await dispatch(setLoader(false));
      } finally {
        await dispatch(setLoader(false));
      }
    } else {
      await dispatch(setLoader(false));
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setInput((prev) => ({
      ...prev,
      [name]: value,
    }));

    // Clear validation error for the current field
    setErrors((prev) => ({
      ...prev,
      [name]: undefined,
    }));
  };

  const onFileChange = (e) => {
    setInput((previous) => ({
      ...previous,
      profilePic: e.target.files[0],
    }));
  };

  const validateForm = () => {
    let valid = true;
    const newErrors = {};

    // Add your validation logic here
    if (!input.firstName || input.firstName.trim() === "") {
      newErrors.firstName = "First name is required";
      valid = false;
    }

     // Add your validation logic here
     if (!input.lastName || input.lastName.trim() === "") {
      newErrors.lastName = "Last name is required";
      valid = false;
    }
    // Email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!input.email ) {
      newErrors.email = "Email is required";
      valid = false;
    }
    else if (!emailRegex.test(input.email)) {
      newErrors.email = "Invalid email address";
      valid = false;
    }

    // Password length validation
    if (!input.password ) {
      newErrors.password = "Password is required";
      valid = false;
    } else if(!/^(?=.*[A-Za-z])(?=.*\d)(?=.*[^A-Za-z\d]).{8,}$/.test(
      input.password.trim()
    )) {
      newErrors.password = "Password must be at least 8 characters long and include at least one digit, and one special character";
      valid = false;
    }

    // Password match validation
    if (input.password !== input.confirmPassword) {
      newErrors.confirmPassword = "Passwords do not match";
      valid = false;
    }

    // Mobile number validation
    const phoneRegex = /^\d{10}$/; // Adjust the regex according to your requirements
    if (!input.phone) {
      newErrors.phone = "Phone number is required";
      valid = false;
    }
    else if (!phoneRegex.test(input.phone)) {
      newErrors.phone = "Invalid phone number";
      valid = false;
    }


    if (!isChecked) {
      newErrors.contract = 'You must agree with the terms and conditions.';
      valid = false;
    } else {
      newErrors.contract = '';
    }


    // if (!input.profilePic) {
    //   newErrors.profilePic = "Please select a profile picture";
    //   valid = false;
    // }

    // Repeat for other fields...
    // failed
    setErrors(newErrors);
    return valid;
  };

  // ***************************************js end*********************************************************

  const onHide = () => {
    props.setRegisterModal(false);
    localStorage.removeItem("facebookData");
    localStorage.removeItem("userData");
  };

  const togglePasswordVisibility = () => {
    setShowPassword((prevShowPassword) => !prevShowPassword);
  };
  const toggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword(
      (prevShowConfirmPassword) => !prevShowConfirmPassword
    );
  };

  return (
    <>
     <Modal
        size="lg"
        show={showModal} centered onHide={handleToggleModal}
      >
        <Modal.Header closeButton>
        </Modal.Header>
        <Modal.Body className='pt-0'>
        <div dangerouslySetInnerHTML={{ __html: content }} />

        </Modal.Body>
      </Modal>
      <Modal
        size="sm"
        show={props.registerModal}
        onHide={onHide}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton></Modal.Header>

        <Modal.Body className="pt-0">
          <h2 className="modal-title text-center">Create Account Consumer</h2>
          <div className="modal-sub-title">
            Welcome to Helpr! We are here to help with your
            <br /> service requests.
          </div>

          <Form
            className="modal-form-wrapper"
            onSubmit={(e) => handleSubmit(e)}
            enctype="multipart/form-data"
            autoComplete="off"
          >
            <Form.Group className="mb-3" controlId="firstname">
              <Form.Label>First Name<span className='req-field'>*</span></Form.Label>
              <Form.Control
                type="text"
                autoComplete="off"
                name="firstName"
                placeholder="Enter your first name"
                value={input.firstName}
                onChange={handleChange}
              />
              {errors.firstName && (
                <span style={{ color: "red" }}>{errors.firstName}</span>
              )}
            </Form.Group>

            <Form.Group className="mb-3" controlId="lastname">
              <Form.Label>Last Name<span className='req-field'>*</span></Form.Label>
              <Form.Control
                type="text"
                autoComplete="off"
                name="lastName"
                placeholder="Enter your last name"
                value={input.lastName}
                onChange={handleChange}
              />
              {errors.lastName && (
                <span style={{ color: "red" }}>{errors.lastName}</span>
              )}
            </Form.Group>
            <Form.Group className="mb-3" controlId="phoneNumber">
              <Form.Label>Phone Number<span className='req-field'>*</span></Form.Label>
              <Form.Control
                type="text"
                autoComplete="off"
                name="phone"
                placeholder="Enter your phone number"
                value={input.phone}
                onChange={handleChange}
              />
              {errors.phone && (
                <span style={{ color: "red" }}>{errors.phone}</span>
              )}
            </Form.Group>

            <Form.Group className="mb-3" controlId="email">
              <Form.Label>Email<span className='req-field'>*</span></Form.Label>
              <Form.Control
                type="text"
                autoComplete="off"
                name="email"
                placeholder="Enter your email"
                value={input.email}
                onChange={handleChange}
              />
              {errors.email && (
                <span style={{ color: "red" }}>{errors.email}</span>
              )}
            </Form.Group>

            <Form.Group className="mb-3" controlId="password">
              <Form.Label>Password<span className='req-field'>*</span></Form.Label>
              <div className="form-wrap">
                <Form.Control
                  type={showPassword ? "text" : "password"}
                  name="password"
                  autoComplete="off"
                  placeholder="Enter your password"
                  onChange={handleChange}
                />
                <div className="icon-wrap" onClick={togglePasswordVisibility}>
                  {showPassword ? <Show /> : <Hide />}
                </div>
              </div>
              {errors.password && (
                <span style={{ color: "red" }}>{errors.password}</span>
              )}
            </Form.Group>
            <Form.Group className="mb-3" controlId="confirmPassword">
              <Form.Label>Confirm Password<span className='req-field'>*</span></Form.Label>
              <div className="form-wrap">
                <Form.Control
                  type={showConfirmPassword ? "text" : "password"}
                  autoComplete="off"
                  name="confirmPassword"
                  placeholder="Enter your confirm password"
                  onChange={handleChange}
                />

                <div
                  className="icon-wrap"
                  onClick={toggleConfirmPasswordVisibility}
                >
                  {showConfirmPassword ? <Show /> : <Hide />}
                </div>
              </div>
              {errors.confirmPassword && (
                <span style={{ color: "red" }}>{errors.confirmPassword}</span>
              )}
            </Form.Group>
            <Form.Group className="mb-3" controlId="termsCondition">
              <div className="d-flex w-100 align-items-center gap-1 form-check-wrapper">
                <Form.Check
                  className="mb-0"
                  type="checkbox"
                  id="contract"
                  label="I agree with the"
                  onChange={()=>setChecked(!isChecked)}

                />
                <span onClick={handleToggleModal}> terms and conditions</span>
              </div>
              {errors.contract && <span style={{ color: 'red' }}>{errors.contract}</span>}
            </Form.Group>
            {/* {loading ? (
              <div className="loader-container">
                <div className="loader"></div>
              </div>
            ) : ( */}
            <Form.Group className="mb-4">
              <div className="d-grid">
                <Button type="submit" variant="primary" size="lg">
                  Sign Up
                </Button>
              </div>
            </Form.Group>
            {/* )} */}

            <div
              className="form-footer text-center w-100 mb-2"
              onClick={() => {
                props.setSignUpModal(true);
                props.setRegisterModal(false);
              }}
            >
              Already have an account? <span>Sign In</span>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default UserRegister;
